var _a;
export var EMutualFundOrderTabs;
(function (EMutualFundOrderTabs) {
    EMutualFundOrderTabs["ALL_TRANSACTIONS"] = "All Transactions";
    EMutualFundOrderTabs["SIPs"] = "SIPs";
    EMutualFundOrderTabs["STPs"] = "STPs";
    EMutualFundOrderTabs["SWPs"] = "SWPs";
    EMutualFundOrderTabs["MANDATES"] = "Mandates";
    EMutualFundOrderTabs["TRANSFER_IN"] = "Transfer-In";
})(EMutualFundOrderTabs || (EMutualFundOrderTabs = {}));
var MutualFundOrderTabIndex = (_a = {},
    _a[EMutualFundOrderTabs.ALL_TRANSACTIONS] = 0,
    _a[EMutualFundOrderTabs.SIPs] = 1,
    _a[EMutualFundOrderTabs.STPs] = 2,
    _a[EMutualFundOrderTabs.SWPs] = 3,
    _a[EMutualFundOrderTabs.MANDATES] = 4,
    _a[EMutualFundOrderTabs.TRANSFER_IN] = 5,
    _a);
// Utility function to get the index
export function getTabIndex(tab) {
    return MutualFundOrderTabIndex[tab];
}
